import React from 'react';
import { QBox, QBoxProps } from '../../QLayouts';

export interface QDrawerFooterProps extends QBoxProps {
  children: React.ReactNode;
}

export const QDrawerFooter: React.FC<QDrawerFooterProps> = ({
  children,
  ...props
}) => {
  return <QBox {...props}>{children}</QBox>;
};

QDrawerFooter.displayName = 'QDrawerFooter';
